module.exports = __webpack_public_path__ + "img/KM-360A_08.dab5ac80.jpg";